import { Outlet, ScrollRestoration } from 'react-router-dom';
import '@/layouts/Empty/stylesEmpty';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useVideo } from '@/contexts/ContentContext';
import classes from './style.module.css';

const EmptyLayout = () => {
  const { isVideoEnded } = useVideo();

  return (
    <div className={classes.layout}>
      <ScrollRestoration />
      {isVideoEnded && <Header />}
      <main>
        <Outlet />
      </main>
      {isVideoEnded && <Footer isFixed isNegative />}
    </div>
  );
};

export default EmptyLayout;
